import React, { useLayoutEffect, useRef, useState } from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
import './PDFViewer.scss'
// Set the worker source for react-pdf
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`

const useWidth = (target) => {
  const [width, setWidth] = useState(null)
  useLayoutEffect(() => {
    setWidth(target.current.getBoundingClientRect().width - 10)
  }, [target])
  // useResizeObserver(target, (entry) => setWidth(entry.contentRect.width))
  return width
}

const PDFViewer = ({
  pdfUrl,
  pdfLoader = <div>Loading document...</div>
}) => {
  const pdfWrapper = useRef()
  const [numPages, setNumPages] = useState(null)
  const [error, setError] = useState(null)
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages)
    setError(null)
  }
  const onDocumentLoadError = (error) => {
    setError(error)
  }
  const width = useWidth(pdfWrapper)
  return (
    <div className='pdf-viewer-container' ref={pdfWrapper}>
      {error && <div className='error'>Error loading PDF: {error.message}</div>}
      <Document
        file={pdfUrl}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={onDocumentLoadError}
        loading={pdfLoader}
      >
        {Array.from(
          new Array(numPages),
          (el, index) => (
            <div key={`page_${index + 1}`} className='pdf-page'>
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                renderTextLayer={false}
                renderAnnotationLayer={false}
                loading={<div>Loading page {index + 1}...</div>}
                width={width}
              />
              <p className='page-number'>Page {index + 1} of {numPages}</p>
            </div>
          )
        )}
      </Document>
    </div>
  )
}

export default PDFViewer
